import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from '@belong/ui';
import UnitLease from 'models/common/UnitLeaseDetail';
import { fetchInitialPrice } from 'store/redux/initial-price/actions';
import { ComparablesStep } from './InitialEstimateSteps/ComparablesStep/ComparablesStep';
import { InitialPricingStep } from './InitialEstimateSteps/InitialPricingStep/InitialPricingStep';

type InitialEstimateModalProps = {
  // All three are passed straight through, and the setup-flow page opens this
  // modal before a unit has been picked — `unit?.basicInfo?.id` below already
  // assumed as much.
  todos: any[] | null;
  unit?: UnitLease;
  address?: string;
  isOpen: boolean;
  addressModel: any;
  onDismiss: () => void;
};

export default function InitialEstimateModal({
  todos,
  unit,
  address,
  isOpen,
  addressModel,
  onDismiss,
}: InitialEstimateModalProps): JSX.Element | null {
  const [showComparables, setShowComparables] = useState(false);
  const [initialEstimate, setInitialEstimate] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    const getInitialPrice = async () => {
      try {
        const initialEstimateData = await dispatch(
          fetchInitialPrice(unit?.basicInfo?.id),
        );

        setInitialEstimate(initialEstimateData);
      } catch (err) {
        console.log(err);
      }
    };

    if (unit?.basicInfo?.id) {
      getInitialPrice();
    }
  }, [dispatch, unit]);

  function onModalDismiss() {
    setShowComparables(false);
    onDismiss();
  }

  if (!initialEstimate) return null;

  return (
    <Modal
      contentClassName="flex"
      isOpen={isOpen}
      name="APP_MODAL"
      onDismiss={onModalDismiss}
      overlayClassName="z-[99999]"
      size="fullScreen"
    >
      <div className="flex w-full justify-center">
        {/*
         * The `!initialEstimate` return above means these only render once the
         * price fetch has resolved, and that fetch only runs for a unit with an
         * id — so a unit and its address are in hand by this point.
         */}
        {showComparables ? (
          <ComparablesStep
            todos={todos}
            address={address!}
            onDismiss={onModalDismiss}
            unit={unit!}
            initialEstimate={initialEstimate}
            addressModel={addressModel}
          />
        ) : (
          <InitialPricingStep
            address={address!}
            unit={unit!}
            initialEstimate={initialEstimate}
            setShowComparables={setShowComparables}
          />
        )}
      </div>
    </Modal>
  );
}
